<template>
  <div class="flex flex-col bg-white flex-no-shrink flex-no-grow border-solid border-r border-grey-lightest w-64">
    <div class="flex relative flex-col h-12 flex-no-shrink flex-no-grow">
      <div class="flex flex-row text-xs pt-3 items-center mt-auto">
          <div @click="setActiveSection('connected')" v-bind:class="[activeSection === 'connected' ? 'font-semibold' : 'hover:text-blue hover:font-semibold']" class="w-1/3 text-grey-darkest text-center cursor-pointer">Connected</div>
          <div @click="setActiveSection('requested')" v-bind:class="[activeSection === 'requested' ? 'font-semibold' : 'hover:text-blue hover:font-semibold']" class="w-1/3 text-grey-darkest text-center cursor-pointer">Request</div>
          <div @click="setActiveSection('consults')" v-bind:class="[activeSection === 'consults' ? 'font-semibold' : 'hover:text-blue hover:font-semibold']" class="w-1/3 text-grey-darkest text-center cursor-pointer">Completed</div>
      </div>
      <div class="flex flex-row h-1 bg-grey-lightest mt-auto">
          <div class="w-1/3" v-bind:class="[activeSection === 'connected' ? 'bg-blue' : '']"></div>
          <div class="w-1/3" v-bind:class="[activeSection === 'requested' ? 'bg-blue' : '']"></div>
          <div class="w-1/3" v-bind:class="[activeSection === 'consults' ? 'bg-blue' : '']"></div>
      </div>
      <div v-if="activeConsults.length>0" class="absolute text-xs bg-green text-white flex flex-row justify-center items-center" style="top: 0rem; left: 1.5rem; width: 2rem; height: 1rem; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%;"> 
        {{activeConsults.length}} 
      </div>
      <div v-if="requests.length>0" class="absolute text-xs bg-red text-white flex flex-row justify-center items-center" style="top: 0rem; left: 7rem; width: 2rem; height: 1rem; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%;">   
        {{requests.length}}
      </div>
      <div v-if="pastConsults.length>0" class="absolute text-xs bg-grey-lighter text-white flex flex-row justify-center items-center" style="top: 0rem; left: 12.5rem; width: 2rem; height: 1rem; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%;">
        {{totalPastConsults}}
      </div>  
    </div>
    <!--Connected Components -->
    <div v-if="activeSection === 'connected'" >
      <div v-if="activeConsults.length === 0">
        <span class="text-sm flex justify-center my-4">No Active Consultations</span>
      </div>
      <active-consultations v-else/>
    </div>
    <!--Requested Components -->
    <div class="relative" v-if="activeSection === 'requested'">
      <div @click="showLoad()" class="flex h-12 text-blue text-sm flex-col flex-no-shrink flex-no-grow pt-4 items-center">
        <div class="flex flex-row items-center cursor-pointer">
          <div class="font-semibold">Active Consultations of Doctors</div>
          <img class="w-5 h-5 flex flex-col" src="../../assets/expand.png">
        </div>
      </div>
      <active-doctors-card v-if="isShowLoad" @closePopup="closePopup"></active-doctors-card>
      <!-- <div class="relative">
      </div> -->
    </div>
    <div class="relative overflow-y-auto" v-if="activeSection === 'requested'">
      <div class="flex flex-row bg-grey-lightest" style="height: .10rem"></div>
        <div v-if="requests.length === 0"> 
          <span class="text-sm flex justify-center my-4">No Patient Request Pending</span>
        </div>
        <incoming-requests v-if="requests.length > 0" />
    </div>
    <!--Past Consult Components -->
    <div class = "flex flex-col overflow-y-auto" v-if="activeSection === 'consults'" >
      <div v-if="pastConsults.length === 0"><span class="text-sm flex justify-center my-4">No past consultations</span></div>
      <past-consultations v-else/>
    </div>
    <!-- Phrases -->
    <!-- <Phrases v-if="false"/> -->
    <UnsavedChangesModal v-if="showSaveReminder" @close='closeModal'/>
  </div>
</template>

<script>
import IncomingRequests from '@/components/Consultations/IncomingRequests'
import ActiveConsultations from '@/components/Consultations/ActiveConsultations.vue'
import PastConsultations from '@/components/Consultations/PastConsultations.vue'
import Phrases from '@/components/Phrases/PhrasesMain'
import ActiveDoctorsCard from '@/components/Consultations/ActiveDoctorsCard'
import UnsavedChangesModal from '@/components/common/modals/UnsavedChanges'
import {mapState, mapGetters} from 'vuex'
export default {
  components: {
    IncomingRequests,
    ActiveConsultations,
    PastConsultations,
    Phrases,
    ActiveDoctorsCard,
    UnsavedChangesModal
  },
  data () {
    return {
      isShowLoad: false,
      showSaveReminder: false
    }
  },
  computed: {
    ...mapGetters({
      requests: 'consultationRequest/getRequests',
      activeSection: 'configuration/getActiveSection'
    }),
    ...mapState({
      activeConsults: state => state.consultation.activeConsults,
      pastConsults: state => state.pastConsultation.pastConsults,
      totalPastConsults: state => state.pastConsultation.totalPastConsults,
      editTextField: state => state.textField.inEdit
    })
  },
  methods: {
    setActiveSection: function (section) {
      if (this.editTextField) {
        this.showSaveReminder = true
        return
      }
      this.isShowLoad = false
      this.$store.dispatch('configuration/setOnlineActiveSection', section)
    },
    showLoad: function () {
      this.isShowLoad = !this.isShowLoad
      if (this.isShowLoad) {
        this.$store.dispatch('consultationRequest/loadDetails')
      }
    },
    closePopup: function (val) {
      this.isShowLoad = val
    },
    closeModal: function (params) {
      this.showSaveReminder = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Consultations/LeftPane.vue